"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.LunaSectionHeaderMargins = exports.LunaSectionHeaderPaddings = exports.LunaSectionHeaderDividers = void 0;

var _lunaContainer = require("../luna-container");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaSectionHeaderDividers = {
  l10: _lunaContainer.LunaContainerDividers.l10.bottom,
  l20: _lunaContainer.LunaContainerDividers.l20.bottom,
  l30: _lunaContainer.LunaContainerDividers.l30.bottom,
  l40: _lunaContainer.LunaContainerDividers.l40.bottom
};
exports.LunaSectionHeaderDividers = LunaSectionHeaderDividers;
var LunaSectionHeaderPaddings = {
  l0: 'padding-bottom-0',
  l10: {
    bottom: _lunaContainer.LunaContainerPaddings.l10.bottom,
    vertical: _lunaContainer.LunaContainerPaddings.l10.vertical
  },
  l20: {
    bottom: _lunaContainer.LunaContainerPaddings.l20.bottom,
    vertical: _lunaContainer.LunaContainerPaddings.l20.vertical
  },
  l30: {
    bottom: _lunaContainer.LunaContainerPaddings.l30.bottom,
    vertical: _lunaContainer.LunaContainerPaddings.l30.vertical
  }
};
exports.LunaSectionHeaderPaddings = LunaSectionHeaderPaddings;

var LunaSectionHeaderMargins = _objectSpread({
  l0: 'margin-bottom-0'
}, _lunaContainer.LunaContainerMargins);

exports.LunaSectionHeaderMargins = LunaSectionHeaderMargins;
var classes = {
  base: 'luna-section-header',
  resetMarginClass: 'luna-section-header-margin-0',
  resetPaddingClass: 'luna-section-header-padding-0'
};
exports.classes = classes;
